var map = {
	"./ai-design-assistant.svg": 914,
	"./architecture.svg": 937,
	"./collaborate.svg": 952,
	"./environment-settings.svg": 691,
	"./insert-appliances.svg": 620,
	"./insert-cabinets.svg": 291,
	"./insert-countertops.svg": 980,
	"./insert-decor.svg": 591,
	"./insert-doors.svg": 627,
	"./insert-electronics.svg": 465,
	"./insert-equipment.svg": 728,
	"./insert-furniture.svg": 846,
	"./insert-hvac.svg": 530,
	"./insert-lighting.svg": 844,
	"./insert-plumbing.svg": 840,
	"./insert-windows.svg": 103,
	"./materials.svg": 346,
	"./multifinish.svg": 958,
	"./product-factory.svg": 312,
	"./render-images.svg": 559,
	"./shopping-cart.svg": 463,
	"./start-from-photos.svg": 405,
	"./view-in-2d.svg": 396,
	"./view-in-3d.svg": 151
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 742;